export class RiskQualification {
  name: string;
  dni: string;
  qualification: number;
  description: string;
  color: string;
}
